const commonProperties = {
  allowedContent: true,
  fillEmptyBlocks: false,
  uiColor: '#ebf2f6',
  versionCheck: false,
  linkDefaultProtocol: '',
}

const disallowedContent = 'img{width,height}'
const filebrowserUploadUrl = '/members-api/upload/'

const toolbar = [
  [
    'Undo',
    'Redo',
    'Bold',
    'Italic',
    'Underline',
    'Link',
    'Unlink',
    'InsertQR',
    'Anchor',
    'Format',
    'SpellChecker',
    'Scayt',
    'TextColor',
    'BGColor',
    'Image',
    'image_embed',
    'Table',
  ],
  ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord'],
  ['HorizontalRule', 'NumberedList', 'BulletedList', 'InsertField'],
  [
    'Outdent',
    'Indent',
    'Blockquote',
    'CreateDiv',
    'JustifyLeft',
    'JustifyCenter',
    'JustifyRight',
    'JustifyBlock',
    'BidiLtr',
    'BidiRtl',
    'Maximize',
    'ClonePage',
    'Source',
  ],
]

const QR_CODE_CSS_CLASS = 'qr-code'
const QR_CODE_HELP_LINK_TEXT = "Can't scan the QR?"
const QR_CODE_IMAGE_WIDTH = '160'
const QR_CODE_PLACEHOLDER_DATA = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA
                                  ASIAAAEiAQAAAAB1xeIbAAABlklEQVR4nO3aQY6jMBCF4f
                                  8NlrI00hyAo9g3mDP1zfBRcoCW8LIlRzULQ6aTXswsmsCA
                                  vUAEfRJPkVUUlcj4+0o//gFBU0011VRTe1eal0PqQTEvV+
                                  KmuU6hgpmZTUC4SjbSmZmZParX5zqFyvMet7ehoAhIctvn
                                  OrJyT58Vrs+XvvmOTS3r+Yu2NBRn5PXu2NSz8mY2AoQJFA
                                  EzK9vnOoFKkpYW52LArbY5W+c6tKo159NgIQ0fAv84athr
                                  +iMoxSyRJNXCQ3aQ+lvr79dUD89aPyE8kPoOoGv9/Zpqrj
                                  lpMBSuwshuKUHZFYVxm1xnUPO+D1dXwBc3H3K/ca7zKKkH
                                  yBdTzBdT9AWzCebyv+/0/6v61OcYFICbjPzTSL9af/8C9W
                                  eOSepB0X8IuLX+fk1FHVfOc8zOoI4wS33DrdPMca/pj6Hu
                                  c8yR+wjTmylunOvI6sscE/8uI/eQdH/h3Wv6w6mu7vb228
                                  mr1DLHrIe3oQDZobhxriOrueak2tF0KEz1zBTG0mrOmkrt
                                  v1FNNdVUU6dQvwFgCZlyyYjj7QAAAABJRU5ErkJggg==`
const SCENARIOS_QR_TEMPLATE = `
  <div>
    <a href="{{ training_url }}">
      <img class="${QR_CODE_CSS_CLASS}"
          src="${QR_CODE_PLACEHOLDER_DATA}"
          style="width: ${QR_CODE_IMAGE_WIDTH}px"
          alt="${QR_CODE_HELP_LINK_TEXT}">
      </br>
      <span style="margin-left: ${QR_CODE_IMAGE_WIDTH / 8}px">
        ${QR_CODE_HELP_LINK_TEXT}
      </span>
    </a>
  </div>
`

const PLACEHOLDER_FIELDS = {
  scenario: {
    'Current Time': '{{ now:%m/%d/%Y %H:%M }}',
    Yesterday: '{{ yesterday:%m/%d/%Y }}',
    Tomorrow: '{{ tomorrow:%m/%d/%Y }}',
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
    'User Email': '{{ to_email }}',
    'Contact Email': '{{ contact_email }}',
    'Training URL': '{{ training_url }}',
    Domain: '{{ domain }}',
    'Company Name': '{{ company_name }}',
  },
  landing: {
    'Current Time': '{{ now:%m/%d/%Y %H:%M }}',
    Yesterday: '{{ yesterday:%m/%d/%Y }}',
    Tomorrow: '{{ tomorrow:%m/%d/%Y }}',
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
    'User Email': '{{ to_email }}',
    'From Email': '<span id="inputTo">{{ from_email }}</span>',
    Subject: '<span id="inputSubject">{{ email_subject }}</span>',
    'Email Body': '<span id="inputBody">{{ email_body }}</span>',
    'Attachment Filename': '<span id="attName">{{ email_attachment }}</span>',
    'Contact Email': '{{ contact_email }}',
    'Training URL': '{{ training_url }}',
    Domain: '{{ domain }}',
    'Start Training': '{{ start_button }}',
  },
  impersonation: {
    'Sender Name': '{{ sender_name }}',
    'Sender Email Address': '{{ sender_address }}',
    'Sender Email Domain': '{{ sender_domain }}',
    'Impersonation Data': '{{ original_sender_name }}',
    'Impersonated Sender Address': '{{ impersonated_address }}',
  },
  endUserDefault: {
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
    'Reporting User': '{{ full_name }}',
    'Reporting Date': '{{ report_date }}',
    'Sender Name': '{{sender_name }}',
    'Sender Email': '{{ sender_email }}',
    'Email Subject': '{{ email_subject }}',
    'Receive Date': '{{ receive_date }}',
    'New Status': '{{ new_status }}',
    Effect: '{{ effect }}',
    'Company Name': '{{ company_name }}',
    'Contact Email': '{{ contact_email }}',
  },
  endUserKnownSender: {
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
    'Full Name': '{{ full_name }}',
    'Sender Name': '{{ sender_name }}',
    'Sender Email': '{{ sender_email | safe_minus_tags }}',
    'Sender Known Change Url': '{{ sender_known_change_url }}',
    'Company Name': '{{ company_name }}',
    'Known Type': '{{ known_type }}',
  },
  endUserMentioningComments: {
    'User Name': '{{ user_name }}',
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
    'Full Name': '{{ full_name }}',
    'Report Subject': '{{ report_subject }}',
    'Company Name': '{{ company_name }}',
    Comment: '{{ comment }}',
  },
  endUserPhishingTrainingReminder: {
    'Company Name': '{{ company_name }}',
    'Full Name': '{{ full_name }}',
    'Training Page Url': '{{ training_page_url }}',
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
  },
  endUserQuarantinedEmailsReport: {
    'Company Name': '{{ company_name }}',
    'First Name': '{{ first_name }}',
  },
  endUserReadMaliciousEmail: {
    'Malicious Email Subject': '{{ email_subject }}',
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
    'Contact Email': '{{ contact_email }}',
  },
  training: {
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
  },
  callforaction: {
    Yesterday: '{{ yesterday:%m/%d/%Y }}',
    Tomorrow: '{{ tomorrow:%m/%d/%Y }}',
    'First Name': '{{ first_name }}',
    'Last Name': '{{ last_name }}',
    'User Email': '{{ to_email }}',
    'Contact Email': '{{ contact_email }}',
    Domain: '{{ domain }}',
    'Company Name': '{{ company_name }}',
  },
}

export const getConfiguration = (type, placeholdersFields) => {
  switch (type) {
    case 'email':
      return {
        ...commonProperties,
        fullPage: true,
        disallowedContent,
        filebrowserUploadUrl,
        toolbar: [
          [
            'Undo',
            'Redo',
            'Bold',
            'Italic',
            'Underline',
            'Link',
            'Unlink',
            'Anchor',
            'Format',
            'SpellChecker',
            'Scayt',
            'TextColor',
            'BGColor',
            'Image',
            'image_embed',
            'Table',
          ],
          [
            'HorizontalRule',
            'Cut',
            'Copy',
            'Paste',
            'PasteText',
            'PasteFromWord',
            'NumberedList',
            'BulletedList',
            'InsertField',
            'Outdent',
            'Indent',
            'Blockquote',
            'CreateDiv',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            'BidiLtr',
            'BidiRtl',
            'Maximize',
            'ClonePage',
            'Source',
          ],
        ],
        extraPlugins: 'insertfield',
        ironscalesFields: PLACEHOLDER_FIELDS[placeholdersFields],
      }
    case 'logo':
      return {
        ...commonProperties,
        disallowedContent,
        filebrowserUploadUrl,
        toolbar: [['Image', 'Source']],
      }
    case 'landing':
      return {
        ...commonProperties,
        disallowedContent,
        filebrowserUploadUrl,
        fullPage: true,
        removeDialogTabs: 'link:upload',
        toolbar,
        extraPlugins: 'insertfield,image_embed',
        ironscalesFields: PLACEHOLDER_FIELDS[type],
      }
    case 'callforaction':
      return {
        ...commonProperties,
        disallowedContent,
        filebrowserUploadUrl,
        fullPage: true,
        removeDialogTabs: 'link:upload',
        toolbar,
        extraPlugins: 'pagecloner,image_embed,insertfield',
        ironscalesPageCloner: true,
        ironscalesFields: PLACEHOLDER_FIELDS[type],
      }
    case 'scenario':
      return {
        ...commonProperties,
        disallowedContent,
        filebrowserUploadUrl,
        removeDialogTabs: 'link:upload',
        toolbar,
        extraPlugins: 'insertfield,image_embed,insert_qr_code',
        ironscalesFields: PLACEHOLDER_FIELDS[type],
        ironscalesQRTemplate: SCENARIOS_QR_TEMPLATE,
      }
    case 'impersonation':
      return {
        ...commonProperties,
        toolbar: [
          {
            name: 'document',
            items: ['Source', 'NewPage', 'Preview', 'Templates'],
          },
          { name: 'basicstyles', items: ['Bold', 'Italic'] },
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'paragraph', items: ['JustifyLeft', 'JustifyRight'] },
        ],
        extraPlugins: 'insertfield',
        ironscalesFields: PLACEHOLDER_FIELDS[type],
      }
    case 'training':
      return {
        ...commonProperties,
        disallowedContent,
        filebrowserUploadUrl,
        removeDialogTabs: 'link:upload',
        toolbar: [
          [
            'Undo',
            'Redo',
            'Bold',
            'Italic',
            'Underline',
            'Link',
            'Unlink',
            'InsertQR',
            'Anchor',
            'Format',
            'SpellChecker',
            'Scayt',
            'TextColor',
            'BGColor',
            'image_embed',
            'Table',
          ],
          ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord'],
          ['HorizontalRule', 'NumberedList', 'BulletedList', 'InsertField'],
          [
            'Outdent',
            'Indent',
            'Blockquote',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
            'BidiLtr',
            'BidiRtl',
            'Maximize',
            'ClonePage',
            'Source',
          ],
        ],
        extraPlugins: 'insertfield,image_embed',
        ironscalesFields: PLACEHOLDER_FIELDS[type],
      }
    default:
      return {
        ...commonProperties,
        toolbar: [
          {
            name: 'document',
            items: ['Source', 'NewPage', 'Preview', 'Templates'],
          },
          { name: 'basicstyles', items: ['Bold', 'Italic'] },
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'paragraph', items: ['JustifyLeft', 'JustifyRight'] },
        ],
      }
  }
}
